export default "__VITE_ASSET__Ddwo4g9A__"